import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { Capability, ParkingRestriction } from '../model';
import { commandPermissions } from './command-permissions';

export interface EvseRoamingSettings {
  evseId: number;
  capabilities: Capability[];
  floorLevel?: string;
  physicalReference?: string;
  parkingRestrictions: ParkingRestriction[];
}

export interface UpdateEvseStaticsCommand {
  evseRoamingData: EvseRoamingSettings[];
}

const client = createClient('/rest/operator-api/charging-stations');

export const updateEvseStatics: SaveOperation<UpdateEvseStaticsCommand, void, string> = postRequestFactory<
  UpdateEvseStaticsCommand,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/update-evse-statics',
  permissionId: commandPermissions.UPDATE_EVSE_STATICS
});
